import {
  LIST_CUSTOMERS,
  ADD_CUSTOMER,
  LIST_MEMBERS_CUSTOMERS,
  GET_CUSTOMER,
  DELETE_CUSTOMER,
} from '../actions/customersActions';
import { ApiCustomerType } from '../features/Customers/types';

export type CustomerListType = {
  items: Array<ApiCustomerType>;
  customerDetail: ApiCustomerType | null;
  members: any;
  total: number;
};

export type CustomersReducerActionType = {
  type: string;
  payload: CustomerListType | ApiCustomerType | string;
};

const defaultState = {
  items: [],
  customerDetail: null,
  members: null,
  total: 0,
};

const customersReducer = (
  state = defaultState,
  action: CustomersReducerActionType
) => {
  switch (action.type) {
    case LIST_CUSTOMERS:
      return action.payload;
    case ADD_CUSTOMER:
      return {
        ...state,
        items: [action.payload, ...state.items],
      };
    case LIST_MEMBERS_CUSTOMERS:
      return {
        ...state,
        members: action.payload,
      };
    case GET_CUSTOMER:
      return {
        ...state,
        customerDetail: action.payload,
      };
    case DELETE_CUSTOMER:
      return {
        ...state,
        items: state.items.filter(
          ({ id }: ApiCustomerType) => id !== action.payload
        ),
      };
    default:
      return state;
  }
};

export default customersReducer;
